export interface ClientDiagnostic {
  code: string;
  occurredAt: string;
}

const diagnostics: ClientDiagnostic[] = [];

export function recordClientDiagnostic(code: string): void {
  if (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(code)) return;
  diagnostics.push({ code, occurredAt: new Date().toISOString() });
  if (diagnostics.length > 5) diagnostics.shift();
}

export function readClientDiagnostics(): readonly ClientDiagnostic[] {
  return diagnostics.slice();
}

export function browserSummary(userAgent: string): string {
  if (userAgent.includes("Edg/")) return "Edge (Chromium)";
  if (/CriOS|Chrome\//.test(userAgent)) return "Chrome (Chromium)";
  if (/FxiOS|Firefox\//.test(userAgent)) return "Firefox";
  if (userAgent.includes("Safari/") && !/Chrome|Chromium/.test(userAgent)) {
    return "Safari (WebKit)";
  }
  return "Unidentified browser engine";
}

/**
 * navigator.platform is deprecated and increasingly spoofed/frozen by
 * browsers, so this reads the same signal off the user agent string
 * instead (consistent with browserSummary above).
 */
export function platformSummary(userAgent: string): string {
  if (userAgent.includes("iPhone") || userAgent.includes("iPad")) {
    return "iOS";
  }
  if (userAgent.includes("Android")) return "Android";
  if (userAgent.includes("Mac OS X")) return "macOS";
  if (userAgent.includes("Windows")) return "Windows";
  if (userAgent.includes("Linux")) return "Linux";
  return "Unidentified platform";
}
